export default () => ({
  _id: '',
  account_locked: false,
  activated: false,
  addresses: [],
  allow_public_key: true,
  attributes: [],
  company: '',
  costCenter: '',
  created: '',
  department: '',
  description: '',
  displayname: '',
  disableDeviceMaxLoginAttempts: false,
  email: '',
  employeeIdentifier: '',
  employeeType: '',
  enable_managed_uid: false,
  enable_user_portal_multifactor: false,
  external_dn: '',
  external_source_type: '',
  externally_managed: false,
  firstname: '',
  jobTitle: '',
  lastname: '',
  ldap_binding_user: false,
  location: '',
  managedAppleId: '',
  mfa: {
    configured: false,
    exclusion: false,
  },
  middlename: '',
  password_expiration_date: '',
  password_expired: false,
  password_never_expires: false,
  passwordless_sudo: false,
  phoneNumbers: [],
  restricted_fields: {},
  samba_service_user: false,
  ssh_keys: [],
  state: 'ACTIVATED',
  sudo: false,
  suspended: false,
  systemUsername: '',
  totp_enabled: false,
  unix_guid: '',
  unix_uid: '',
  username: '',
  manager: null,
  alternateEmail: '',
  recoveryEmail: {
    address: '',
    verified: false,
    verifiedAt: null,
  },
  // TODO: Add additional extended attributes here!
});
